const LoginTypes = {
  PhoneNumber: 1,
  Email: 2,
};

export default LoginTypes;
